<template>
  <div class="notice-dialog">
    <el-dialog
      title="平台服务协议 & 隐私权协议"
      :visible.sync="dialogVisible"
      :show-close="false"
      :center="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      width="80%"
    >
			<div style="height: calc(90vh - 230px);">
				<div ref="serverBox" v-show="step ==  1" style="height: 100%;overflow-y:auto;" @scroll="scroll" >
					<div ref="serverContent" v-html="serverHtml">
						<!-- <pdf
						 v-for="i in oneNumPages"
						:key="i"
						:src="pdfUrlOne"
						:page="i"
						@num-pages="pageCount=$event"
						></pdf> -->
					</div>
				</div>

				<div ref="privacyBox" v-show="step == 2" style="height: 100%;overflow-y:auto;" @scroll="scroll">
					<div ref="privacyContent" v-html="privacyHtml">
						<!-- <pdf
						 v-for="i in twoNumPages"
						:key="i"
						:src="pdfUrlTwo"
						:page="i"
						@num-pages="pageCount=$event"
						></pdf> -->
					</div>
				</div>
			</div>

      <!-- <el-form inline ref="form" :model="form" :rules="rules" label-width="120px">
				<el-form-item ref="handReadOne" v-if="step == 1" label="" prop="hadReadOne" style="display: block;text-align: center;">
					<div @click.prevent="hadReadClick">
						<el-checkbox v-model="form.hadReadOne">
							<span style="color: #606266;">已阅读并同意《平台服务协议》</span>
						</el-checkbox>
					</div>
				</el-form-item>
				<el-form-item v-else label="" prop="hadReadTwo" style="display: block;text-align: center;">
					<div @click.prevent="hadReadClick">
						<el-checkbox v-model="form.hadReadTwo">
							<span style="color: #606266;">已阅读并同意《隐私权协议》</span>
						</el-checkbox>
					</div>
				</el-form-item>
			</el-form> -->

      <div slot="footer" class="dialog-footer">
				<el-button v-show="step == 1" type="text" @click="logOut">退 出</el-button>
				<el-button v-show="step == 2" type="text" @click="step = 1">上一步</el-button>
        <el-button v-show="step == 1" type="primary" @click="goNext" :disabled="timeCount1 > 0"><span v-if="timeCount1">（{{ timeCount1 }}）</span>我已阅读并同意《平台服务协议》</el-button>
				<el-button v-show="step == 2" type="primary" @click="submitForm" :disabled="timeCount2 > 0"><span v-if="timeCount2">（{{ timeCount2 }}）</span>我已阅读并同意《隐私权协议》</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import pdf from 'vue-pdf'
import axios from "axios"
import { agreeloginAgreement }  from '@/api/login'

export default {
  name: 'loginAgreement',
  components: { pdf },
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
  data() {
		const hadReadValidator = (rule, value, cb) => {
			if(this.step == 1) {
				// if(!this.hadReadOne) return cb(new Error('请先滚动至底部确认阅读完毕'))
				if(!value) return cb(new Error('请确认协议并勾选同意'))
				cb()
			}else {
				// if(!this.hadReadTwo) return cb(new Error('请先滚动至底部确认阅读完毕'))
				if(!value) return cb(new Error('请确认协议并勾选同意'))
				cb()
			}
		}


    return {
      dialogVisible: this.visible,
			step: 1,
			serverHtml: null,
			privacyHtml: null,
			hadReadOne: false,
			hadReadTwo: false,
			pdfUrlOne: '',
			pdfUrlTwo: '',
			oneNumPages: null,
			twoNumPages: null,
			pdfLoading: true,
			form: {
				hadReadOne: false,
				hadReadTwo: false,
			},
			rules: {
				hadReadOne: { validator: hadReadValidator, trigger: 'change' },
				hadReadTwo: { validator: hadReadValidator, trigger: 'change' }
			},

      timeCount1: 5,
      timeCount2: 5,
		}
  },
  watch: {
		visible(newVal) {
			this.dialogVisible = newVal
		},
		dialogVisible(newVal) {
			if(newVal) {
				this.hadReadOne = false
				this.hadReadTwo = false
				this.getLoginAgreement()
			}
			this.$emit('update:visible', newVal)
		},
  },
  mounted() {
		this.init()
  },
  methods: {
		init() {
			// const one = 'https://tax-plan.oss-cn-shenzhen.aliyuncs.com/file/business/contract_20230320/F10A5097F07A48AC8F1B92F74FD1273D_SIGN_1637755035014672386.pdf?Expires=1686736972&OSSAccessKeyId=LTAI4G58o74d1xEBcb1Ct2Pm&Signature=QPD4CI9q6FvsNaSGf5s83cUF0UU%3D'
			// this.pdfUrlOne = pdf.createLoadingTask(one)
			// this.pdfUrlTwo = pdf.createLoadingTask(one)
			// this.pdfUrlOne.promise.then(pdf => {
			// 	this.oneNumPages = pdf.numPages
			// })
			// this.pdfUrlTwo.promise.then(pdf => {
			// 	this.twoNumPages = pdf.numPages
			// })
			if(this.dialogVisible) {
        this.timeCount1 = 5
        this.timeCount2 = 5
				this.getLoginAgreement()
			}
		},
		logOut() {
			this.$store.dispatch('LogOut').then(() => {
			  location.reload()
			})
		},
		// 复选框点击
		hadReadClick() {
			if(this.step == 1) {
				if(this.$refs.serverBox.offsetHeight  >= this.$refs.serverContent.offsetHeight ) {
					this.hadReadOne = true
				}
				if(this.hadReadOne) {
					this.form.hadReadOne = !this.form.hadReadOne
				}else {
					this.$refs.form.validateField('hadReadOne')
				}
			}else {
				if(this.$refs.privacyBox.offsetHeight  >= this.$refs.privacyContent.offsetHeight ) {
					this.hadReadTwo = true
				}
				if(this.hadReadTwo) {
					this.form.hadReadTwo = !this.form.hadReadTwo
				}else {
					this.$refs.form.validateField('hadReadTwo')
				}
			}
		},
		goNext() {
      this.step = 2
      if (this.timeCount2 > 0) {
        this.countdown('timeCount2')
      }
		},
		submitForm() {
      agreeloginAgreement().then(res => {
        this.dialogVisible = false
      }).catch(() => {})
		},
    scroll(e) {
			if (e.srcElement.scrollTop + e.srcElement.clientHeight > e.srcElement.scrollHeight - 30) {//-30距离底部50px是触发以下内容
				if(this.step == 1 && !this.hadReadOne) {
					this.hadReadOne = true
					this.$refs.form.clearValidate('hadReadOne')
				}
				if(this.step == 2 && !this.hadReadTwo){
					this.hadReadTwo = true
					this.$refs.form.clearValidate('hadReadTwo')
				}
			}
		},
		// 获取登录协议
		getLoginAgreement() {
			const orgCode = this.$store.getters.platformInfo.orgCode
			const serverHtmlUrl = '/platform/' + orgCode + '/platform_policy.html'
			const privacyHtmlUrl = '/platform/' + orgCode + '/privacy_policy.html'
      this.countdown('timeCount1')
			axios.get(serverHtmlUrl).then(res => {
				 this.serverHtml = res.data || ''
			})
			axios.get(privacyHtmlUrl).then(res => {
				 this.privacyHtml = res.data || ''
			})
		},
    // 倒计时
    countdown(counter) {
      setTimeout(() => {
        this[counter]--
        if (this[counter] > 0) {
          this.countdown(counter)
        }
      }, 1000);
    }
  }
}
</script>

<style lang="scss">

.el-dialog {
  .el-dialog__header {
    padding-top: 10px;
    border-bottom: 1px solid #e4e7ed;
  }
  .el-dialog__body {
    padding: 10px 20px;
    padding-bottom: 10px !important;
  }
  // .el-dialog__footer {
  //   border-top: 1px solid #e4e7ed;
  //   padding-bottom: 10px;
  // }
}
.dialog-footer{
  text-align: center;
}
</style>
